import { IApplicationState } from '../../types/redux';

export const getIsCompareFlightModalOpen = (state: IApplicationState): boolean =>
  state.compareFlightTooltip.isCompareFlightModalOpen;
